import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TdBlockTitleComponent } from "./td-block-title.component";
import { MatTableModule } from "@angular/material/table";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {IconNameToDefinitionModule} from "../../../../../../../../libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        ConfigurationResourceModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    exports: [
        TdBlockTitleComponent,
    ],
    declarations: [
        TdBlockTitleComponent,
    ],
})
export class TdBlockTitleModule {}
